const getSortedNumbersAscending = (start, end) => {
    const [startIndex, endIndex] = [start, end].sort((a, b) => a - b)

    return [startIndex, endIndex]
}

export { getSortedNumbersAscending }